import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';

@inject(stores => ({
  flasher: stores.app.flasher,
  confirmationDialog: stores.app.confirmationDialog,
}))
@observer
export class Messenger extends React.Component {
  @action.bound dismissErrors() {
    const { flasher } = this.props;
    for (let error of flasher.errors) {
      flasher.dismissError(error.id)
    }
  }

  render() {
    const { flasher } = this.props;
    return (
      <div>
        <div className="loader-container">
          {flasher.anyInProgress && <div className="loader-content">
            <div className="loader"></div>
          </div>}
        </div>
        <div className={"error-modal-container" + (flasher.errors.length > 0 ? " active" : "")}>
          <div className="error-wrapper">
            <div className="error-modal-close" onClick={this.dismissErrors}><i className="fa fa-times"></i></div>
            {flasher.errors.map(error =>
              <div className="error-message-item" key={error.id}>
                {/*<b>{error.scope}</b>: */}{error.message}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/view/Flasher/component.js